import { CheckboxControlProps } from "./CheckBoxControl.types";
import { useClassNames } from "../../../../structure";

export const CheckboxControl = <T, P>({
  getValidationClassName,
  onCheckedChange,
  control,
  formState,
  value,
  error,
}: CheckboxControlProps<T, P>): React.ReactElement => {
  const classNames = useClassNames(["formCheck", ...getValidationClassName()].concat(control.classNames || []));
  return (
    <input
      type="checkbox"
      style={classNames}
      checked={!!value}
      onChange={onCheckedChange}
      disabled={!!control.disabledIf && control.disabledIf(formState)}
    />
  );
};
